module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/purchase/account-receivable-payment/ar-payment-form/ar-payment-form.component.css
// module id = ./src/app/Pages/purchase/account-receivable-payment/ar-payment-form/ar-payment-form.component.css
// module chunks = main